// extracted by mini-css-extract-plugin
export default {"loadingWrap":"index_loadingWrap__vUxLN","loadContent":"index_loadContent__zC18O","text":"index_text__UL+PN"};